import React, { FC } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import cn from 'classnames';

import { selectedRouteAction } from '@store/actions';
import useDeviceType from '@hooks/useDeviceType';

import st from './MobileShowMapBtn.module.css';

type MobileShowMapBtnProps = {
  handleSelectedRoute: () => void;
  className?: string;
  isDetailed?: boolean;
  empty?: boolean;
};

const MobileShowMapBtn: FC<MobileShowMapBtnProps> = ({
  className = null,
  isDetailed = false,
  handleSelectedRoute,
  empty = false,
}) => {
  const { desktop } = useDeviceType();
  const history = useHistory();

  if (desktop || !isDetailed) {
    return null;
  }

  const classNameContainer = cn(st.showMapContainer, className);

  const handleClick = () => {
    if (empty) {
      handleSelectedRoute();
    }

    history.push(history.location.pathname, {
      showMobileMapFromDetailed: true,
    });
  };

  return (
    <div className={classNameContainer}>
      <button type="button" onClick={handleClick} className={st.showMap}>
        Показать на карте
      </button>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  handleSelectedRoute: () => dispatch(selectedRouteAction(null)),
});

export default connect(null, mapDispatchToProps)(MobileShowMapBtn);
